export const PAGE_NAME = "wallet-page";
